/*
 *   File : text-input.js
 *   Author : https://evoqins.com
 *   Description : Text input component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { memo, useState } from "react";

//custom style
import styles from "../../Style/Components/input.module.scss";
import { PrimaryButton } from "../Cta";

const CustomSearchInput = (props) => {
  const [isInputFocused, setIsInputFocused] = useState(false);

  // handle focus
  const _handleFocus = () => {
    setIsInputFocused(true);
  };

  const _handleBlur = () => {
    setIsInputFocused(false);
  };

  //input handle change
  const _handleChange = (e) => {
    let value = e.target.value;
    props.handleChange(value);
  };

  // handle enter key press
  const keyPress = (e) => {
    if (e.keyCode === 13) {
      props.onKeyPress();
    }
  };

  return (
    <div>
      {props.label && (
        <label
          className={`${props.labelStyle} e-text-rich-black e-primary-font-poppins e-font-weight-500 e-font-14 pb-2`}
        >
          {props.label}
        </label>
      )}

      <div
        className={`rounded-pill e-border-1px-transparent border-0 ${
          isInputFocused ? `e-border-1px-purple ` : ` ${props.borderStyle}`
        }   position-relative`}
      >
        <img
          src={require("../../Assets/Image/search.png")}
          width={18}
          height={18}
          draggable={false}
          className={`position-absolute ${styles.e_search_icon}`}
          alt="search"
        />
        <input
          id={props.id}
          ref={props.ref}
          value={props.value}
          defaultValue={props.defaultValue}
          maxLength={props.maxLength}
          tabIndex={props.tabIndex}
          type={props.type}
          required={props.required}
          readOnly={props.readOnly}
          autoFocus={props.autoFocus}
          placeholder={props.placeholder}
          className={`${styles.e_search_input} ${props.className} rounded-pill bg-white e-font-14 e-text-black e-font-weight-400  e-primary-font-poppins`}
          onWheel={() => document.activeElement.blur()}
          onFocus={_handleFocus}
          onBlur={_handleBlur}
          onChange={_handleChange}
          onKeyDown={(e) => keyPress(e)}
          onClick={props.onClick}
        />

        {props.value !== "" && (
          <div className=" h-42px position-absolute d-flex column-gap-2 top-1px end-0">
            <PrimaryButton
              icon="close-button"
              ClassName="bg-transparent p-0"
              onPress={() => {
                _handleChange({ target: { value: "" } });
              }}
              size="12px"
            />
            <div onClick={() => props.onKeyPress()} className=" e-cursor-pointer e-bg-blue-violet p-2 e-border-end-rounded">
              <img
                
                width={"16px"}
                src={require("../../Assets/Image/right-white.png")}
                alt="enter"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

CustomSearchInput.defaultProps = {
  onKeyPress: () => {},
  className: null,
  error: "",
};

export default memo(CustomSearchInput);
